module.exports = __webpack_public_path__ + "img/tappy-medium-gray.62a594fc.svg";